/**
 * Paleta fixa para pies/bars dos widgets de clientes.
 * Suficiente para 7 fatias sem repetir, alinhada com tema dark do shell.
 */
export const CHART_COLORS = [
  '#3B82F6',
  '#A855F7',
  '#F59E0B',
  '#10B981',
  '#EF4444',
  '#06B6D4',
  '#EC4899',
] as const;

/**
 * Map de origens conhecidas para labels mais legiveis. Origens fora do map
 * sao mostradas como veio do backend (com primeira letra maiuscula).
 */
const SOURCE_LABELS: Record<string, string> = {
  google: 'Google',
  instagram: 'Instagram',
  facebook: 'Facebook',
  indicacao: 'Indicação',
  promad: 'PROMAD',
  whatsapp: 'WhatsApp',
  site: 'Site',
  outras: 'Outras',
  nao_informado: 'Não informado',
};

export function formatSource(source: string): string {
  return (
    SOURCE_LABELS[source] ??
    source.charAt(0).toUpperCase() + source.slice(1).replace(/_/g, ' ')
  );
}

const AGE_RANGE_LABELS: Record<string, string> = {
  '0-17': '0-17',
  '18-25': '18-25',
  '26-35': '26-35',
  '36-50': '36-50',
  '51-65': '51-65',
  '65+': '65+',
  nao_informado: 'Não informado',
};

export function formatAgeRange(range: string): string {
  return AGE_RANGE_LABELS[range] ?? range;
}

export function formatProfession(profession: string): string {
  if (profession === 'nao_informado') return 'Não informado';
  if (profession === 'outras') return 'Outras';
  return profession.charAt(0).toUpperCase() + profession.slice(1);
}
